<template>
  <span
    class="confidence-badge"
    :style="confidenceStyle"
  >
    {{ confidenceBadge.name }}
    <span v-if="count">({{ count }})</span>
  </span>
</template>

<script>
import { INSIGHTS_CONFIDENCE_LEVELS } from '~/app_constants';

export default {
  name: 'InsightsUnusualActivityConfidenceBadge',
  props: {
    confidenceLevel: {
      type: [Number, String],
      required: true,
    },
    count: {
      type: Number,
      required: false,
      default: null,
    }
  },
  computed: {
    confidenceBadge() {
      return INSIGHTS_CONFIDENCE_LEVELS[parseInt(this.confidenceLevel, 10)];
    },
    confidenceStyle() {
      return {
        color: this.confidenceBadge.color,
        backgroundColor: this.confidenceBadge.lightColor,
      };
    },
  },
};
</script>
